// Categorias fixas de cabine dos cards "Mais Procurados" (/cruzeiros).
// A ordem aqui é a mesma usada como fallback de "Todas" (Interna 1 → Varanda 4)
// e a mesma exibida no filtro público e no admin CMS.
// "interna_2" é a categoria padrão pré-selecionada e recebe rótulo "Dupla".
export const CRUZEIRO_CABINES = [
  { key: "interna_1", label: "Interna 1 Pessoa",       short: "Interna 1" },
  { key: "varanda_1", label: "Varanda 1 Pessoa",       short: "Varanda 1" },
  { key: "interna_2", label: "Dupla Interna 2 Pessoas", short: "Dupla Interna 2" },
  { key: "interna_3", label: "Interna 3 Pessoas",       short: "Interna 3" },
  { key: "interna_4", label: "Interna 4 Pessoas",       short: "Interna 4" },
  { key: "varanda_2", label: "Varanda 2 Pessoas",       short: "Varanda 2" },
  { key: "varanda_3", label: "Varanda 3 Pessoas",       short: "Varanda 3" },
  { key: "varanda_4", label: "Varanda 4 Pessoas",       short: "Varanda 4" },
];

export const DEFAULT_CABINE = "interna_2";

export const cabineLabel = (key) =>
  CRUZEIRO_CABINES.find((c) => c.key === key)?.label || key;

export const emptyCabinesForm = () =>
  CRUZEIRO_CABINES.reduce((acc, c) => {
    acc[c.key] = { link: "", preco: "", m2: "" };
    return acc;
  }, {});

export const formatBRL = (v) => {
  if (v == null || v === "" || Number.isNaN(Number(v))) return null;
  try {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 0,
    }).format(Number(v));
  } catch {
    return `R$ ${Number(v).toFixed(0)}`;
  }
};
